"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    y: 1 << 0,
    n: 1 << 1,
    a: 1 << 2,
    p: 1 << 3,
    u: 1 << 4,
    x: 1 << 5,
    d: 1 << 6
};



//////////////////
// WEBPACK FOOTER
// ./~/caniuse-lite/dist/lib/supported.js
// module id = 1199
// module chunks = 0